import { OfferPageActions, OfferPageFilterType } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import React, { ComponentProps, useCallback, useRef } from 'react'
import OfferCalendarDatePicker from './OfferCalendarDatePicker'
import OfferCalendarDatePickerSelectBox from './OfferCalendarDatePickerSelectBox'
import DropdownSheetBase from 'components/Luxkit/Dropdown/Sheet/DropdownSheetBase'

interface Props extends Pick<ComponentProps<typeof DropdownSheetBase>, 'boundaryRef' | 'open' | 'placement'> {
  useRooms?: boolean;
  defaultDayPicker?: boolean;
  defaultMonth?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /**
   * Provide a list of 'sub filters' to show as part of this component
   */
  subFilters?: Array<OfferPageFilterType>;
  className?: string
}

function OfferCalendarDatePickerSelect(props: Props) {
  const {
    boundaryRef,
    placement,
    open,
    useRooms,
    defaultDayPicker,
    defaultMonth,
    onClick,
    subFilters,
    className,
  } = props
  const isMobile = useScreenSizeOnly('mobile')

  const dispatch = useOfferPageDispatch()

  const onClose = useCallback(() => {
    dispatch({ type: OfferPageActions.setRoomType, room: undefined })
    dispatch({ type: OfferPageActions.closeFilter })
  }, [dispatch])
  const scrollRef = useRef<HTMLDivElement>(null)
  const triggerRef = useRef<HTMLButtonElement>(null)

  return (<div className={className}>
    <OfferCalendarDatePickerSelectBox
      ref={triggerRef}
      onClick={onClick}
    />
    <DropdownSheetBase
      open={open && !isMobile}
      size="XL"
      height="max"
      placement={placement}
      onClose={onClose}
      anchorRef={triggerRef}
      triggerRef={triggerRef}
      boundaryRef={boundaryRef}
      data-testid="offer-checkin-select"
    >
      <OfferCalendarDatePicker
        defaultDayPicker={defaultDayPicker}
        defaultMonth={defaultMonth}
        useRooms={useRooms}
        subFilters={subFilters}
        scrollRef={scrollRef}
      />
    </DropdownSheetBase>
  </div>
  )
}

export default withOfferPageState(state => ({
  open: state.activeFilter === 'checkin',
}), OfferCalendarDatePickerSelect)
